<form #summaryForm="ngForm">
<table aria-labelledby="entity_data">
    <tr><th id="entity_data" colspan="3" scope="colgroup">Dane podmiotu</th></tr>
    <tr>
        <td>Nazwa firmy</td>
        <td colspan="2">{{company.name}}<span *ngIf="!company.name" class="error" pTooltip="Pole nie może być puste. Skontaktuj się z {{companyType==CompanyType.PHYSICAL ? 'CEIDG' : 'KRS'}}" tooltipPosition="top">brak</span></td>
    </tr>
    <tr *ngIf="companyType==CompanyType.PHYSICAL">
        <td>Imię/imiona</td>
        <td colspan="2">{{company.personalData?.firstname}}<span *ngIf="!company.personalData?.firstname" class="error" pTooltip="Pole nie może być puste. Skontaktuj się z CEIDG" tooltipPosition="top">brak</span></td>
    </tr>
    <tr *ngIf="companyType==CompanyType.PHYSICAL">
        <td>Nazwisko:</td>
        <td colspan="2">{{company.personalData?.surname}}<span *ngIf="!company.personalData?.surname" class="error" pTooltip="Pole nie może być puste. Skontaktuj się z CEIDG" tooltipPosition="top">brak</span></td>
    </tr>
    <tr *ngIf="companyType!=CompanyType.PHYSICAL">
        <td>KRS</td>
        <td colspan="2">{{company.krs}}<span *ngIf="!company.krs" class="error" pTooltip="Pole nie może być puste. Skontaktuj się z KRS" tooltipPosition="top">brak</span></td>
    </tr>
    <tr>
        <td>NIP</td>
        <td colspan="2">{{company.nip}}<span *ngIf="!company.nip" class="error" pTooltip="Pole nie może być puste. Skontaktuj się z {{companyType==CompanyType.PHYSICAL ? 'CEIDG' : 'KRS'}}" tooltipPosition="top">brak</span></td>
    </tr>
    <tr *ngIf="companyType==CompanyType.PHYSICAL && noPesel">
        <td><i class="pi pi-check-circle" aria-hidden="true"></i></td>
        <td colspan="2">Nie posiada numeru PESEL</td>
    </tr>
    <tr *ngIf="companyType==CompanyType.PHYSICAL && noPesel">
        <td>Rodzaj dokumentu</td>
        <td colspan="2" [ngClass]="{'error' : !company.personalData.identityType}">{{company.personalData.identityType ? identityTypesMap.get(company.personalData.identityType) : 'brak'}}</td>
    </tr>
    <tr *ngIf="companyType==CompanyType.PHYSICAL && noPesel">
        <td>Seria i numer</td>
        <td colspan="2" [ngClass]="{'error' : !company.personalData.identityValue}">{{company.personalData.identityValue ?? 'brak'}}</td>
    </tr>
    <tr *ngIf="companyType==CompanyType.PHYSICAL && !noPesel">
        <td>PESEL</td>
        <td colspan="2" [ngClass]="{'error' : !company.personalData.pesel}">{{company.personalData.pesel ? company.personalData.pesel : 'brak'}}</td>
    </tr>
    <tr><td></td><td>Adres siedziby</td><td *ngIf="companyType==CompanyType.PHYSICAL">Adres korespondencyjny</td></tr>
    <tr>
        <td>Kraj</td>
        <td>{{company.hqAddress.country}}<span *ngIf="!company.hqAddress.country" class="error" pTooltip="Pole nie może być puste. Skontaktuj się z {{companyType==CompanyType.PHYSICAL ? 'CEIDG' : 'KRS'}}" tooltipPosition="top">brak</span></td>
        <td *ngIf="companyType==CompanyType.PHYSICAL">{{company.correspondenceAddress?.country}}<span *ngIf="!company.correspondenceAddress?.country" class="error" pTooltip="Pole nie może być puste. Skontaktuj się z CEIDG" tooltipPosition="top">brak</span></td>
    </tr>
    <tr>
        <td>Miejscowość</td>
        <td>{{company.hqAddress.city}}<span *ngIf="!company.hqAddress.city" class="error" pTooltip="Pole nie może być puste. Skontaktuj się z {{companyType==CompanyType.PHYSICAL ? 'CEIDG' : 'KRS'}}" tooltipPosition="top">brak</span></td>
        <td *ngIf="companyType==CompanyType.PHYSICAL">{{company.correspondenceAddress?.city}}<span *ngIf="!company.correspondenceAddress?.city" class="error" pTooltip="Pole nie może być puste. Skontaktuj się z CEIDG" tooltipPosition="top">brak</span></td>
    </tr>
    <tr>
        <td>Kod pocztowy</td>
        <td>{{company.hqAddress.postalCode}}<span *ngIf="!company.hqAddress.postalCode" class="error" pTooltip="Pole nie może być puste. Skontaktuj się z {{companyType==CompanyType.PHYSICAL ? 'CEIDG' : 'KRS'}}" tooltipPosition="top">brak</span></td>
        <td *ngIf="companyType==CompanyType.PHYSICAL">{{company.correspondenceAddress?.postalCode}}<span *ngIf="!company.correspondenceAddress?.postalCode" class="error" pTooltip="Pole nie może być puste. Skontaktuj się z CEIDG" tooltipPosition="top">brak</span></td>
    </tr>
    <tr>
        <td>Ulica</td>
        <td>{{company.hqAddress.street}}<span *ngIf="!company.hqAddress.street" class="error" pTooltip="Pole nie może być puste. Skontaktuj się z {{companyType==CompanyType.PHYSICAL ? 'CEIDG' : 'KRS'}}" tooltipPosition="top">brak</span></td>
        <td *ngIf="companyType==CompanyType.PHYSICAL">{{company.correspondenceAddress?.street}}<span *ngIf="!company.correspondenceAddress?.street" class="error" pTooltip="Pole nie może być puste. Skontaktuj się z CEIDG" tooltipPosition="top">brak</span></td>
    </tr>
    <tr>
        <td>Numer</td>
        <td>{{company.hqAddress.number}}<span *ngIf="!company.hqAddress.number" class="error" pTooltip="Pole nie może być puste. Skontaktuj się z {{companyType==CompanyType.PHYSICAL ? 'CEIDG' : 'KRS'}}" tooltipPosition="top">brak</span></td>
        <td *ngIf="companyType==CompanyType.PHYSICAL">{{company.correspondenceAddress?.number}}<span *ngIf="!company.correspondenceAddress?.number" class="error" pTooltip="Pole nie może być puste. Skontaktuj się z CEIDG" tooltipPosition="top">brak</span></td>
    </tr>
</table>
<table *ngIf="companyType==CompanyType.LEGAL" aria-labelledby="shareholders_data">
    <tr><th id="shareholders_data" colspan="7" scope="colgroup">Członkowie zarządu</th></tr>
    <tr>
        <th scope="col">#</th>
        <th scope="col">Imię/imiona</th>
        <th scope="col">Nazwisko</th>
        <th scope="col">NIP</th>
        <th scope="col">PESEL</th>
        <th *ngIf="!onlyPesels" scope="col">Rodzaj dokumentu</th>
        <th *ngIf="!onlyPesels" scope="col">Numer dokumentu</th>
        <th scope="col">Zaświadczenie z KRK</th>
    </tr>
    <tr *ngIf="!company.shareholders?.length">
        <td colspan="8" class="error">Brak członków zarządu. Nie można złożyć wniosku. Skontaktuj się z KRS aby poprawić dane.</td>
    </tr>
    <tr *ngFor="let shareholder of company.shareholders; index as i">
        <td>{{i+1}}</td>
        <td>{{shareholder.personalData?.firstname}}</td>
        <td>{{shareholder.personalData?.surname}}</td>
        <td>{{shareholder.nip}}</td>
        <td>{{shareholder.personalData?.pesel}}</td>
        <td *ngIf="!onlyPesels">{{shareholder.personalData?.identityType ? identityTypesMap.get(shareholder.personalData!.identityType!) : ''}}</td>
        <td *ngIf="!onlyPesels">{{shareholder.personalData?.identityValue}}</td>
        <td style="text-align: center"><i class="{{shareholder.personalData?.krkId ? 'pi pi-check-circle' : 'pi pi-times-circle red'}}" aria-hidden="true"></i></td>
    </tr>
</table>
<table *ngIf="companyType==CompanyType.PARTNERSHIP" aria-labelledby="partners_data">
    <tr><th id="partners_data" colspan="9" scope="colspan">Wspólnicy</th></tr>
    <tr>
        <th scope="col">#</th>
        <th scope="col"></th>
        <th scope="col">Nazwa</th>
        <th scope="col">KRS</th>
        <th scope="col">NIP</th>
        <th scope="col">PESEL</th>
        <th *ngIf="!onlyPesels" scope="col">Rodzaj dokumentu</th>
        <th *ngIf="!onlyPesels" scope="col">Numer dokumentu</th>
        <th scope="col">Zaświadczenie z KRK</th>
    </tr>
    <tr *ngIf="!partners.length">
        <td colspan="9" class="error">Brak wspólników. Nie można złożyć wniosku. Skontaktuj się z KRS aby poprawić dane.</td>
    </tr>
    <tr *ngFor="let partner of partners">
        <td>{{partner.label}}</td>
        <td><i class="pi {{partner.physical ? 'pi-user' : 'pi-building'}}" aria-hidden="true"></i></td>
        <td>{{partner.name}}</td>
        <td>{{partner.krs}}</td>
        <td>{{partner.nip}}</td>
        <td>{{partner.pesel}}</td>
        <td *ngIf="!onlyPesels">{{partner.idType}}</td>
        <td *ngIf="!onlyPesels">{{partner.idValue}}</td>
        <td style="text-align: center">
            <i *ngIf="partner.physical" class="{{partner.krkId ? 'pi pi-check-circle' : 'pi pi-times-circle red'}}" aria-hidden="true"></i>
        </td>
    </tr>
</table>
<table *ngIf="isAssignee" aria-labelledby="assignee_data">
    <tr><th id="assignee_data" colspan="2" scope="colgroup">Dane pełnomocnika</th></tr>
    <tr><td>Imię/imiona</td><td [ngClass]="{'error' : !proxy.firstname}">{{proxy.firstname ?? 'brak'}}</td></tr>
    <tr><td>Nazwisko</td><td [ngClass]="{'error' : !proxy.surname}">{{proxy.surname ?? 'brak'}}</td></tr>
    <tr><td>Adres do doręczeń</td><td [ngClass]="{'error' : !proxy.address}">{{proxy.address ?? 'brak'}}</td></tr>
    <tr><td>Plik upoważnienia</td><td [ngClass]="{'error' : !authFileName}">{{authFileName ?? 'brak'}}</td></tr>
    <tr><td>Opłata za pełnomocnictwo</td><td [ngClass]="{'error' : !authPaymentFileName}">{{authPaymentFileName ?? 'brak'}}</td></tr>
</table>
<table aria-labelledby="attachments_data">
    <tr><th id="attachments_data" colspan="2" scope="colgroup">Załączniki</th></tr>
    <tr *ngIf="companyType==CompanyType.PHYSICAL"><td>Plik zaświadczenia z Krajowego Rejestru Karnego o niekaralności za przestępstwa</td><td [ngClass]="{'error' : !krkFileName}">{{krkFileName ?? 'brak'}}</td></tr>
    <tr><td>Plik dowodu uiszczenia opłaty za wniosek o wpis/zmianę wpisu do rejestru</td><td [ngClass]="{'error' : !paymentFileName}">{{paymentFileName ?? 'brak'}}</td></tr>
    <tr><td>Plik aktualnego odpisu z {{companyType==CompanyType.PHYSICAL ? 'Centralnej Ewidencji i Informacji o Działalności Gospodarczej (CEIDG)' : 'Krajowego Rejestru Sądowego (KRS)'}}</td><td [ngClass]="{'error' : !registerFileName}">{{registerFileName ?? 'brak'}}</td></tr>
</table>
<table aria-labelledby="contact_data">
    <tr><th id="contact_data" colspan="2" scope="colgroup">Dane kontaktowe</th></tr>
    <tr><td>Imię i nazwisko</td><td [ngClass]="{'error' : !company.contactData.contactPerson}">{{company.contactData.contactPerson ?? 'brak'}}</td></tr>
    <tr><td>E-mail</td><td [ngClass]="{'error' : !company.contactData.email}">{{company.contactData.email ?? 'brak'}}</td></tr>
    <tr><td>Telefon komórkowy</td><td>{{company.contactData.mobilePhone ?? '-'}}</td></tr>
    <tr><td>Telefon stacjonarny</td><td>{{company.contactData.landlinePhone ?? '-'}}</td></tr>
</table>
<br/>
<table aria-label="Oświadczenia">
    <tr><th scope="col">Oświadczam, że <i class="pi pi-info-circle" pTooltip="Wymagane zaznaczenie wszystkich kwadratów" aria-hidden="true"></i>:</th></tr>
    <tr><td>
        <p-checkbox [binary]="true" label="Dane zawarte we wniosku i załącznikach są aktualne, kompletne i zgodne z prawdą*" [ngModel]="dataAgree"
                    (ngModelChange)="dataAgreeChange.emit($event)" [required]="true" name="dataAgree"></p-checkbox>
        <small *ngIf="summaryFormDirty && !dataAgree" class="p-error block">
            <div>
                Akceptacja jest wymagana
            </div>
        </small>
    </td></tr>
    <tr><td>
        <p-checkbox [binary]="true" label="Znane mi są warunki wykonywania działalności gospodarczej w charakterze pośrednika kredytowego, określone w ustawie*"
                    [ngModel]="conditionsAgree" (ngModelChange)="conditionsAgreeChange.emit($event)" [required]="true" name="condAgree"></p-checkbox>
        <small *ngIf="summaryFormDirty && !conditionsAgree" class="p-error block">
            <div>
                Akceptacja jest wymagana
            </div>
        </small>
    </td></tr>
    <tr><td>
        <p-checkbox [binary]="true" inputId="rd"
                    [ngModel]="rodoAgree" (ngModelChange)="rodoAgreeChange.emit($event)" [required]="true" name="rdAgree"></p-checkbox>&nbsp;
        <label for="rd">Zapoznałam/em się z treścią
            <a [routerLink]="[]" (click)="showRodo()">klauzuli informacyjnej</a> i wyrażam zgodę na przetwarzanie danych osobowych*
        </label>
        <small *ngIf="summaryFormDirty && !rodoAgree" class="p-error block">
            <div>
                Akceptacja jest wymagana
            </div>
        </small>
    </td></tr>
</table>
</form>

<p-dialog header="Klauzula RODO"
          [(visible)]="rodoVisible"
          [modal]="true"
          [draggable]="false"
          [resizable]="false"
          [closable]="true"
          styleClass="w-11 md:wp-6">
    <rodo></rodo>
</p-dialog>